/* eslint-disable react/prop-types */
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'

function FeatureToggleSnackbar({ snackbar, onClose }) {
  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={5000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={onClose} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>
        {snackbar.message}
      </Alert>
    </Snackbar>
  )
}

export default FeatureToggleSnackbar
